import { useState } from 'react';
import { JournalPanel } from './JournalPanel';
import { ExpensesPanel } from './ExpensesPanel';

/**
 * Le livre des entrées et sorties du compte, distinct du suivi des loyers par
 * bail (onglet Finances) : loger toutes les dépenses récurrentes et
 * ponctuelles à côté du suivi de rentabilité aurait fini par le noyer.
 */
export function ComptabilitePanel() {
  const [year, setYear] = useState(String(new Date().getFullYear()));
  const years = [0, 1, 2].map((offset) => String(new Date().getFullYear() - offset));

  return (
    <section className="panel">
      <div className="section-heading">
        <div><p className="eyebrow">Livre de comptes</p><h2>Comptabilité {year}</h2></div>
        <div className="finances-toolbar">
          <select value={year} onChange={(event) => setYear(event.target.value)}>
            {years.map((value) => <option key={value} value={value}>{value}</option>)}
          </select>
        </div>
      </div>

      <JournalPanel year={year} />
      <ExpensesPanel year={year} />
    </section>
  );
}
